import { render, staticRenderFns } from "./pop-data-device.vue?vue&type=template&id=82fc6d58&scoped=true&"
import script from "./pop-data-device.vue?vue&type=script&lang=js&"
export * from "./pop-data-device.vue?vue&type=script&lang=js&"
import style0 from "./pop-data-device.vue?vue&type=style&index=0&id=82fc6d58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fc6d58",
  null
  
)

export default component.exports